var exports = {
  "Kk": "InviteEmbed.module__icon___UTY5bl",
  "EU": "InviteEmbed.module__iconFallback___UTY5bl",
  "C1": "InviteEmbed.module__titleRowWithIcon___UTY5bl",
  "gn": "InviteEmbed.module__titleContainer___UTY5bl",
  "Qw": "InviteEmbed.module__titleText___UTY5bl",
  "fH": "InviteEmbed.module__headerInvite___UTY5bl",
  "dT": "InviteEmbed.module__inviteWrapper___UTY5bl",
  "M1": "InviteEmbed.module__stats___UTY5bl",
  "dJ": "InviteEmbed.module__stat___UTY5bl",
  "gW": "InviteEmbed.module__statDot___UTY5bl",
  "rR": "InviteEmbed.module__statDotOnline___UTY5bl",
  "rb": "InviteEmbed.module__statDotMembers___UTY5bl",
  "KA": "InviteEmbed.module__statText___UTY5bl",
};

module.exports = exports;
